import React from 'react';
import Tooltip from './Tooltip';

const IngredientTooltip = ({ ingredient, target, mobileMode, onClose }) => {
  if (!ingredient || !ingredient.sources) {
    return null;
  }

  const recipeSources = ingredient.sources.filter(s => s.type === 'recipe');
  const isAdditionalItem = ingredient.sources.some(s => s.type === 'additional_item');

  return (
    <Tooltip target={target} mobileMode={mobileMode} onClose={onClose}>
      {mobileMode && (
        <div className="tooltip-header">
          <button className="icon-button close-tooltip-button" onClick={onClose}>
            <i className="material-icons">close</i>
          </button>
        </div>
      )}
      {recipeSources.length > 0 && (
        <>
          <h4>Recipes</h4>
          <hr />
        </>
      )}
      <ul>
        {recipeSources.map((source, index) => (
          <li key={`recipe-${index}`}>{source.name}</li>
        ))}
        {isAdditionalItem && recipeSources.length > 0 && (
          <>
            <hr />
          </>
        )}
        {isAdditionalItem && (
          <>
            <li key="additional">Additional Item(s)</li>
          </>
        )}
      </ul>
    </Tooltip>
  );
};

export default IngredientTooltip;